module.exports = __webpack_public_path__ + "static/media/tap_supplychain_visualization.a3d6e34a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/tap_supplychain_visualization.webp
// module id = 641
// module chunks = 0